import { createFileRoute } from "@tanstack/react-router";
import { OtherConsentFormsPage } from "@/features/consents";
import { patientDomainIdFromProfile } from "@/shared/lib/patient-profile";

export const Route = createFileRoute("/_consented/consent-forms")({ component: Page });

function Page() {
  const { profile } = Route.useRouteContext();
  return <OtherConsentFormsPage patientId={patientDomainIdFromProfile(profile)} />;
}
